import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  CircularProgress,
  Alert,
  Typography
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { updateUserRoles } from '../../../services/api';

function EditSupervisorModal({ open, supervisor, onClose, onSuccess, token }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [maxTherapistCapacity, setMaxTherapistCapacity] = useState(10);

  useEffect(() => {
    if (open && supervisor) {
      setMaxTherapistCapacity(supervisor.supervisorInfo?.maxTherapistCapacity || 10);
      setError('');
    }
  }, [open, supervisor]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');

      const updatedSupervisorInfo = {
        ...supervisor.supervisorInfo,
        maxTherapistCapacity
      };

      await updateUserRoles(supervisor._id, {
        roles: supervisor.role,
        supervisorInfo: updatedSupervisorInfo
      }, token);

      onSuccess();
    } catch (err) {
      console.error('Error updating supervisor:', err);
      setError(err.message || 'Failed to update supervisor settings');
      setLoading(false);
    }
  };

  if (!supervisor) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditIcon />
          Edit Supervisor Settings
        </Box>
      </DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Box sx={{ pt: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            {supervisor.name}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 3, display: 'block' }}>
            {supervisor.email}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              label="Max Therapist Capacity"
              type="number"
              fullWidth
              value={maxTherapistCapacity}
              onChange={(e) => setMaxTherapistCapacity(parseInt(e.target.value) || 10)}
              inputProps={{ min: 1, max: 50 }}
              helperText={`Currently assigned: ${supervisor.supervisorInfo?.assignedTherapists?.length || 0} therapists`}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <EditIcon />}
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditSupervisorModal;
